/* DJ's homepage sections — motion + commerce glue (vanilla, no deps). Safe to load once per page. */
(function () {
  if (window.__djsHomeInit) { window.__djsHomeInit(); return; }
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inited = new WeakSet();

  function init() {
    /* ---- staggered reveals ---- */
    var reveals = Array.prototype.slice.call(document.querySelectorAll('.djs-reveal:not(.djs-is-in)'));
    if (reduce || !('IntersectionObserver' in window) || window.Shopify && window.Shopify.designMode) {
      reveals.forEach(function (el) { el.classList.add('djs-is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var sibs = Array.prototype.slice.call(e.target.parentElement.querySelectorAll(':scope > .djs-reveal'));
          var i = Math.max(0, sibs.indexOf(e.target));
          e.target.style.transitionDelay = (e.target.closest('.djs-hero') ? 0.5 : Math.min(i, 6) * 0.09) + 's';
          e.target.classList.add('djs-is-in'); io.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
      reveals.forEach(function (el) { io.observe(el); });
    }

    /* ---- craftsmanship hotspots ---- */
    document.querySelectorAll('.djs-anatomy').forEach(function (sec) {
      if (inited.has(sec)) return; inited.add(sec);
      var spots = Array.prototype.slice.call(sec.querySelectorAll('.djs-hotspot'));
      var specs = Array.prototype.slice.call(sec.querySelectorAll('.djs-spec'));
      function setSpot(n) {
        spots.forEach(function (s) { s.classList.toggle('djs-is-active', s.dataset.spot === String(n)); });
        specs.forEach(function (s) { s.classList.toggle('djs-is-active', s.dataset.spot === String(n)); });
      }
      spots.concat(specs).forEach(function (s) { s.addEventListener('click', function () { setSpot(s.dataset.spot); }); });
      var auto = 0, idx = 0;
      if (!reduce && spots.length > 1 && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var e = en[0];
          if (e.isIntersecting && !auto) auto = setInterval(function () { idx = (idx + 1) % spots.length; setSpot(idx); }, 4200);
          else if (!e.isIntersecting && auto) { clearInterval(auto); auto = 0; }
        }, { threshold: 0.35 }).observe(sec);
        sec.addEventListener('click', function () { if (auto) { clearInterval(auto); auto = 0; } }, { once: true });
      }
    });

    /* ---- collections rail ---- */
    document.querySelectorAll('[data-djs-rail]').forEach(function (rail) {
      if (inited.has(rail)) return; inited.add(rail);
      var down = false, startX = 0, startL = 0, moved = false;
      rail.addEventListener('pointerdown', function (e) { down = true; moved = false; startX = e.clientX; startL = rail.scrollLeft; });
      rail.addEventListener('pointermove', function (e) {
        if (!down) return; var dx = e.clientX - startX;
        if (Math.abs(dx) > 4 && !moved) { moved = true; rail.classList.add('djs-is-dragging'); try { rail.setPointerCapture(e.pointerId); } catch (_) {} }
        if (moved) rail.scrollLeft = startL - dx;
      });
      var up = function () { down = false; setTimeout(function () { rail.classList.remove('djs-is-dragging'); }, 40); };
      rail.addEventListener('pointerup', up); rail.addEventListener('pointercancel', up);
      rail.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } }, true);
      var sec = rail.closest('.djs-collections');
      sec && sec.querySelectorAll('.djs-rail__btn').forEach(function (b) {
        b.addEventListener('click', function () {
          var card = rail.querySelector('.djs-rail__card'); if (!card) return;
          var w = card.getBoundingClientRect().width + 18;
          rail.scrollBy({ left: w * 2 * Number(b.dataset.dir), behavior: reduce ? 'auto' : 'smooth' });
        });
      });
    });

    /* ---- patio: variant picker + AJAX add to cart ---- */
    document.querySelectorAll('[data-djs-patio]').forEach(function (sec) {
      if (inited.has(sec)) return; inited.add(sec);
      var stage = sec.querySelector('[data-djs-stage]');
      var swatches = Array.prototype.slice.call(sec.querySelectorAll('.djs-swatch'));
      var label = sec.querySelector('[data-djs-colour]');
      var idInput = sec.querySelector('[data-djs-variant-id]');
      var addBtn = sec.querySelector('[data-djs-add]');
      var addLabel = sec.querySelector('[data-djs-add-label]');
      var baseLabel = addLabel ? addLabel.textContent.split('—')[0].trim() : 'Add to cart';
      function pick(sw) {
        var id = sw.dataset.variant;
        if (stage) stage.querySelectorAll('img').forEach(function (im) { im.classList.toggle('djs-is-active', im.dataset.variant === id); });
        swatches.forEach(function (s) { s.setAttribute('aria-checked', s === sw ? 'true' : 'false'); });
        if (label) label.textContent = sw.dataset.title;
        if (idInput) idInput.value = id;
        sec.style.setProperty('--tint', sw.dataset.hex);
        if (addBtn && addLabel) {
          var ok = sw.dataset.available === 'true';
          addBtn.disabled = !ok;
          addLabel.innerHTML = ok ? (sw.dataset.price ? baseLabel + ' — <span data-djs-price>' + sw.dataset.price + '</span>' : baseLabel) : 'Sold out';
        }
      }
      swatches.forEach(function (sw) { sw.addEventListener('click', function () { pick(sw); }); });
      var form = sec.querySelector('form[data-type="djs-patio-form"]');
      if (form) {
        form.addEventListener('submit', function (e) {
          var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          var routes = window.routes || {};
          if (customElements.get('product-form-component') && form.closest('product-form-component')) return; // Horizon theme handles it
          if (!window.fetch || !cart || typeof cart.renderContents !== 'function') return; // native submit → /cart
          e.preventDefault();
          if (addBtn.getAttribute('aria-disabled') === 'true') return;
          addBtn.setAttribute('aria-disabled', 'true'); addBtn.classList.add('djs-is-loading');
          var fd = new FormData(form);
          try { fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; })); fd.append('sections_url', window.location.pathname); cart.setActiveElement && cart.setActiveElement(document.activeElement); } catch (_) {}
          fetch(routes.cart_add_url || '/cart/add', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
            .then(function (r) { return r.json(); })
            .then(function (resp) {
              if (resp.status) { throw new Error(resp.description || 'Could not add to cart'); }
              document.dispatchEvent(new CustomEvent('cart:add', { detail: { id: idInput.value, qty: 1 } }));
              if (window.publish && window.PUB_SUB_EVENTS) { try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: idInput.value, cartData: resp }); } catch (_) {} }
              cart.renderContents(resp);
            })
            .catch(function () { window.location.href = routes.cart_url || '/cart'; })
            .finally(function () { addBtn.removeAttribute('aria-disabled'); addBtn.classList.remove('djs-is-loading'); });
        });
      }
    });

    /* ---- odometer counters ---- */
    var counts = Array.prototype.slice.call(document.querySelectorAll('.djs-count'));
    if (counts.length && 'IntersectionObserver' in window) {
      var fmt = function (el, v) { if (el.dataset.fixed) return v.toFixed(Number(el.dataset.fixed)); var n = Math.round(v); return el.dataset.plain ? String(n) : n.toLocaleString('en-CA'); };
      var co = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return; co.unobserve(e.target);
          var el = e.target, to = Number(String(el.dataset.to).replace(/[^0-9.]/g, ''));
          if (isNaN(to)) return;
          if (reduce) { el.textContent = fmt(el, to); return; }
          var t0 = performance.now(), dur = 1600, from = el.dataset.plain ? to - 60 : 0;
          (function tick(t) { var p = Math.min(1, (t - t0) / dur); var ease = 1 - Math.pow(1 - p, 3); el.textContent = fmt(el, from + (to - from) * ease); if (p < 1) requestAnimationFrame(tick); })(t0);
        });
      }, { threshold: 0.5 });
      counts.forEach(function (c) { if (!inited.has(c)) { inited.add(c); co.observe(c); } });
    }
  }

  window.__djsHomeInit = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* Theme editor: re-init when a section is (re)loaded */
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 50); });
})();
